if (!customElements.get('sft-gloves-upsell')) {
  customElements.define('sft-gloves-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-gloves-data]').textContent);
      this.opt = this.querySelector('[data-gloves-opt]');
      this.size = this.querySelector('[data-gloves-size]');
      this.form = document.getElementById(this.dataset.formId);
      this.product = this.data.products[0];
      this.populateSizes();
      this.captureAdd = event => {
        if (!this.opt.checked || !this.isConnected) return;
        const button = event.target.closest('button[name="add"]');
        if (!button || button.form !== this.form || button.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.form.closest('product-form').handleSubmit(event);
      };
      window.addEventListener('click', this.captureAdd, true);
      this.captureSubmit = event => {
        if (!this.opt.checked || event.target !== this.form) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.form.closest('product-form').handleSubmit(event);
      };
      window.addEventListener('submit', this.captureSubmit, true);
      this.opt.addEventListener('change', () => {
        this.form.querySelectorAll('.product-dynamic-payment-button').forEach(el => { el.hidden = this.opt.checked; });
        this.size.setCustomValidity('');
      });
      this.size.addEventListener('change', () => {
        this.size.setCustomValidity('');
        this.opt.checked = Boolean(this.size.value);
        this.opt.dispatchEvent(new Event('change'));
      });
      this.querySelectorAll('[data-gloves-color]').forEach(button => button.addEventListener('click', () => {
        const previous = this.product.variants.find(v => String(v.id) === this.size.value)?.title;
        this.product = this.data.products.find(p => String(p.id) === button.dataset.glovesColor);
        this.querySelectorAll('[data-gloves-color]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.querySelector('[data-gloves-color-name]').textContent = button.dataset.colorName;
        const image = this.querySelector('.sft-gloves__image');
        image.removeAttribute('srcset');
        image.src = this.product.image;
        image.alt = this.product.title;
        this.populateSizes(previous);
      }));
    }
    disconnectedCallback() {
      window.removeEventListener('click', this.captureAdd, true);
      window.removeEventListener('submit', this.captureSubmit, true);
      this.ready = false;
    }
    populateSizes(previous) {
      this.size.replaceChildren(new Option(this.data.chooseSize, ''));
      [...this.product.variants].sort((a,b) => parseInt(a.title,10)-parseInt(b.title,10)).forEach(v => {
        const available = v.available && v.price === 2490;
        const option = new Option(v.title + (available ? '' : ' — ' + this.data.soldOut), String(v.id));
        option.disabled = !available;
        option.selected = available && v.title === previous;
        this.size.append(option);
      });
      this.size.setCustomValidity('');
    }
    validateSelection() {
      if (!this.opt.checked) return true;
      const variant = this.product.variants.find(v => String(v.id) === this.size.value);
      if (variant?.available && variant.price === 2490) return true;
      this.size.setCustomValidity(this.data.sizeError);
      this.size.scrollIntoView({block:'center',behavior:'smooth'});
      this.size.reportValidity();
      return false;
    }
    prepareCart(data) {
      if (!this.opt.checked) return;
      const entries = [...data.entries()];
      for (const [key, value] of entries) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          const nested = key.startsWith('properties[') ? 'properties][' + key.slice(11,-1) : key;
          data.append('items[0][' + nested + ']', value);
          data.delete(key);
        }
      }
      const quantity = Math.max(1, parseInt(data.get('items[0][quantity]') || '1', 10));
      data.set('items[0][quantity]', String(quantity));
      data.set('items[1][id]', this.size.value);
      data.set('items[1][quantity]', String(quantity));
    }
  });
}
